import React, { useRef, useState } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import Text from '../../../../global/text/text';
import { IConnectionDetailsDTO, IConnectionGroupDTO } from '../../../../../api/connections.dao';
import ConnectionGroupDetailsPopup from './connection-group-detail-popup/connection-group-detail-popup';
import { ConnectionGroupsPassportPreviewViewModel } from './connection-groups-passport-preview/connection-group-passport-preview.viewmodel';

type ConnectionGroupListItemProps = {
    group: IConnectionGroupDTO;
    editButtonText: JSX.Element;
    orderedConnections: (group: IConnectionGroupDTO) => IConnectionDetailsDTO[];
    onEditGroup: (group: IConnectionGroupDTO) => void;
    editGroupPermission: boolean;
    isSelected: boolean;
    connectionGroupsPassportPreviewViewModel: ConnectionGroupsPassportPreviewViewModel;
};

export const ConnectionGroupListItem = observer((props: ConnectionGroupListItemProps): JSX.Element => {
    const {
        group,
        editButtonText,
        orderedConnections,
        onEditGroup,
        editGroupPermission,
        isSelected,
        connectionGroupsPassportPreviewViewModel,
    } = props;
    const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
    const listItemRef = useRef(null);

    const onTogglePopover = (): void => {
        setIsPopoverOpen(prev => !prev);
    };

    return (
        <>
            <div
                className={classnames('connection-list__item connection-list__item--with-hover', {
                    'connection-list__item--active': isPopoverOpen || isSelected
                })}
                ref={listItemRef}
                onClick={onTogglePopover}
            >
                <Text tag='p' message={group.label} withEllipsis />
            </div>
            <div className='connection-item-popover'>
                <ConnectionGroupDetailsPopup
                    isPopoverOpen={isPopoverOpen}
                    closePopup={() => {
                        setIsPopoverOpen(false);
                    }}
                    listItemRef={listItemRef}
                    onEditGroup={onEditGroup}
                    orderedConnections={orderedConnections}
                    group={group}
                    editButtonText={editButtonText}
                    editGroupPermission={editGroupPermission}
                    connectionGroupsPassportPreviewViewModel={connectionGroupsPassportPreviewViewModel}
                />
            </div>
        </>
    );
});
